import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { useCallback, useMemo } from 'react';
import ExpandCollapseCell from 'src/components/custom-cells/ExpandCollapseCell';
import useVarianceDetails from 'src/hooks/useVarianceDetails';
const VarianceGLCodeHeaderCell = (props: GridHeaderCellProps) => {
  const { varianceGLPeriods, setVarianceGLPeriods } = useVarianceDetails();

  const isAllItemsExpanded = useMemo(
    () =>
      varianceGLPeriods?.every((lineItem) =>
        lineItem?.glCodeVariances.every((glCode) => !!glCode.expanded)
      ),
    [varianceGLPeriods]
  );
  const handleHeaderCellExpand = useCallback(() => {
    setVarianceGLPeriods((prev) =>
      [...prev].map((item) => ({
        ...item,
        glCodeVariances: item.glCodeVariances.map((glCode) => ({
          ...glCode,
          expanded: !isAllItemsExpanded,
        })),
      }))
    );
  }, [isAllItemsExpanded, setVarianceGLPeriods]);

  return (
    <th className="k-header k-hierarchy-cell" style={{ borderBottomWidth: '0px' }}>
      <ExpandCollapseCell
        expand={isAllItemsExpanded}
        onExpand={handleHeaderCellExpand}
        title="Expand/Collapse All"
      />
    </th>
  );
};
export default VarianceGLCodeHeaderCell;
